import { trackEvent } from '@saaga/shared/utils/analytics.util'
import { logger } from '@saaga/shared/utils/logger.util'
import { useCallback } from 'react'
import { toast } from 'sonner'

import type { ClerkMembershipsResource } from './members-clerk.types'

interface UseLeaveOrganizationProps {
  memberships: ClerkMembershipsResource | null
  currentUserId: string | null
}

interface UseLeaveOrganizationReturn {
  handleLeaveOrganization: () => Promise<void>
}

export const useLeaveOrganization = ({
  memberships,
  currentUserId,
}: UseLeaveOrganizationProps): UseLeaveOrganizationReturn => {
  const handleLeaveOrganization = useCallback(async (): Promise<void> => {
    const currentMembership = memberships?.data?.find(
      (m) => m.publicUserData?.userId === currentUserId
    )
    if (!currentMembership) return

    const adminCount = memberships?.data?.filter((m) => m.role === 'org:admin').length ?? 0
    if (currentMembership.role === 'org:admin' && adminCount <= 1) {
      toast.error('Cannot leave organization. You are the only admin.')
      return
    }

    try {
      await currentMembership.destroy()
      trackEvent('organization_left', {})
      toast.success('You have left the organization')
    } catch (error) {
      logger.error('Failed to leave organization:', error)
      toast.error('Failed to leave organization')
    }
  }, [memberships, currentUserId])

  return { handleLeaveOrganization }
}
